import { enUS, fr, de, zhCN, es, type Locale } from "date-fns/locale";

export const getDateFnsLocale = (i18nLocale?: string): Locale => {
  switch (i18nLocale) {
    case "en":
      return enUS;
    case "es":
      return es;
    case "fr":
      return fr;
    case "zh":
      return zhCN;
    case "de":
      return de;
    default:
      return enUS;
  }
};
